interface DetectedBarcode {
  rawValue: string;
}
interface BarcodeDetectorLike {
  detect(source: HTMLVideoElement): Promise<DetectedBarcode[]>;
}
type BarcodeDetectorConstructor = new (options?: { formats?: string[] }) => BarcodeDetectorLike;

export function barcodeDetector(): BarcodeDetectorConstructor | undefined {
  return (window as unknown as { BarcodeDetector?: BarcodeDetectorConstructor }).BarcodeDetector;
}

/** Camera scanning needs the browser's BarcodeDetector and a camera. */
export function cameraScanSupported(): boolean {
  return Boolean(barcodeDetector()) && 'getUserMedia' in (navigator.mediaDevices ?? {});
}
